import mutations from "./mutations.js";
import actions from "./actions.js";
import getters from "./getters.js";

import { ref } from "vue";

export default {
  namespaced: true,

  state() {
    const tmp_nazioni = ref([]);
    const tmp_utenti = ref([]);
    const tmp_mezzi = ref([]);
    const tmp_servizi = ref([]);
    const tmp_serviziForm = ref([]);
    const tmp_tipiPersona = ref([]);
    const tmp_tipologie = ref([]);
    const tmp_trattamenti = ref([]);
    const tmp_lingue = ref([]);
    const tok = ref("");

    return {
      tok: tok.value,
      tipologie: tmp_tipologie.value,
      trattamenti: tmp_trattamenti.value,
      tipiPersona: tmp_tipiPersona.value,
      servizi: tmp_servizi.value,
      serviziForm: tmp_serviziForm.value,
      mezzi: tmp_mezzi.value,
      utenti: tmp_utenti.value,
      lingue: tmp_lingue.value,
      nazioni: tmp_nazioni.value,
      preventivi: [],
      orari: {
        orario: {
          hours: 9,
          minutes: 0,
          seconds: 0,
        },
        checkinStr: [
          {
            hours: 10,
            minutes: 0,
            seconds: 0,
          },
          {
            hours: 13,
            minutes: 30,
            seconds: 0,
          },
        ],
        checkoutStr: [
          {
            hours: 16,
            minutes: 0,
            seconds: 0,
          },
          {
            hours: 19,
            minutes: 30,
            seconds: 0,
          },
        ],
        checkinCamp: [
          {
            hours: 10,
            minutes: 0,
            seconds: 0,
          },
          {
            hours: 13,
            minutes: 30,
            seconds: 0,
          },
        ],
        checkoutCamp: [
          {
            hours: 16,
            minutes: 0,
            seconds: 0,
          },
          {
            hours: 19,
            minutes: 30,
            seconds: 0,
          },
        ],
        checkin: [
          {
            hours: 10,
            minutes: 0,
            seconds: 0,
          },
          {
            hours: 13,
            minutes: 30,
            seconds: 0,
          },
        ],
        checkout: [
          {
            hours: 16,
            minutes: 0,
            seconds: 0,
          },
          {
            hours: 19,
            minutes: 30,
            seconds: 0,
          },
        ],
      },
      occupazione: [
        "%",
        [0, 33, 66, 100],
        [
          "rgb(199, 54, 44)",
          "rgb(214, 130, 52)",
          "rgb(199, 183, 44)",
          "rgb(44, 199, 52)",
        ],
        [
          {
            title: "Rosso",
            description: "Non disponibile",
          },
          {
            title: "Arancione",
            description: "Ultime disponibilità",
          },
          {
            title: "Giallo",
            description: "Poca disponibilità",
          },
          {
            title: "Verde",
            description: "Disponibile",
          },
        ],
      ],

      contatti: {
        tel: "",
        whatsapp: "",
        mail: "",
        indirizzo: "",
        policyLink: ["", ""],
      },
      messaggiDiDefault: [],
      terminiDiCancellazione: [],
    };
  },
  mutations,
  actions,
  getters,
};
